import React, { useState, useEffect } from 'react';

// SECURITY 2026-08-17: три ендпоінти нижче тепер під Depends(verify_token)
// на бекенді, тому кожен fetch мусить нести Bearer — той самий токен, що
// LoginPage кладе у localStorage['dashboard_token'].
const _authOpts = () => ({
  headers: { Authorization: 'Bearer ' + (localStorage.getItem('dashboard_token') || '') },
});


// ─── Дані системи ──────────────────────────────────────────────────────────

const PROJECTS = [
  {
    id: 'ava', emoji: '🎭', name: 'MediaAvatar', code: 'AVA',
    account: '💎 Media', color: 'var(--ac2, #a78bfa)',
    desc: 'Telegram mini-app для генерації AI-відео з аватаром і голосом',
    bootstrap: 'videobot-docs/_SESSIONS/ava/BOOTSTRAP.md',
    state: 'videobot-docs/_SESSIONS/ava/STATE.md',
    skill: '/resume ava',
    lastD: 'D-291 — Live duration counter + AI rewrite + undo (2026-06-29)',
    next: ['Двоблоковий VOICE/VISUAL скрипт', 'Прибрати debug ({choices.length})', 'EMOTION_UI — нова модель'],
    bugs: [],
    keyFiles: [
      { path: 'dashboard/miniapp/src/apps/mediaavatar/Screens.jsx', desc: 'Головний UI екран', lines: ':572 EMOTION_UI, :590-650 duration' },
      { path: 'dashboard/miniapp/src/apps/mediaavatar/MediaAvatarApp.jsx', desc: 'Роутинг між екранами' },
      { path: 'dashboard/api/avatar_routes.py', desc: 'API: /generate /result /script /trends /voices' },
      { path: 'dashboard/miniapp/src/i18n/translations.js', desc: 'i18n mav_* ключі ×8 мов' },
    ]
  },
  {
    id: 'uniq', emoji: '🎬', name: 'Media Uniqueizer Bot', code: 'UNIQ',
    account: '💎 Media', color: '#34d399',
    desc: 'Telegram-бот унікалізації відео (хромакеї, заставки, субтитри, AI)',
    bootstrap: 'videobot-docs/_SESSIONS/uniq/BOOTSTRAP.md',
    state: 'videobot-docs/_SESSIONS/uniq/STATE.md',
    skill: '/resume uniq',
    lastD: 'Ревізія 19.08.2026 — топологію звірено; до того: top-up AI-варіантів (08.08), індив. ліміт часу F#18 в editor_jobs (05.08), автолікування черги (05.08)',
    next: ['netcup-1 відключається 05.09.2026 — зняти чергу client_netcup_1', 'Секрет mono-поллера в URL → заголовок (видно в логах nginx)', 'Прибрати мертві pcapp_price_* з referral_settings', 'Диск n8n 78% — почистити .bak'],
    bugs: [],
    keyFiles: [
      { path: '/opt/video_bot/bot/main.py', desc: 'Prod бот (n8n), md5: 80c9aa44 (19.08.2026)', lines: '' },
      { path: '/opt/video_bot/celery_tasks.py', desc: 'Celery broker/backend, _resolve_redis_pw()' },
      { path: '/opt/video_bot/bot/video_process.py', desc: 'Обробка відео: хромакеї, заставки, субтитри' },
      { path: '/usr/local/bin/sync_celery.sh', desc: 'Щогодини тягне 5 файлів з n8n → test, worker-5, staging (атомарно через /tmp+mv)' },
    ]
  },
  {
    id: 'pcapp', emoji: '🖱', name: 'Autopilot Studio (PC-App)', code: 'PCAPP',
    account: '💎 Media', color: '#22d3ee',
    desc: 'Десктоп-застосунок Windows: унікалізація на машині користувача, а не на серверах (Tauri v2 + ffmpeg 8.1.2)',
    bootstrap: 'videobot-docs/_SESSIONS/pcapp/HANDOFF_PCAPP.md',
    state: 'videobot-docs/_SESSIONS/pcapp/ПЛАН_ПК_УНІКАЛІЗАТОР.md',
    skill: '—',
    lastD: 'pcapp_enabled=true (увімкнено). Інсталятор NSIS 1.0.0, 53.6 МБ, зібрано 10.07.2026',
    next: ['Реальних користувачів ЩЕ НЕМАЄ (1 пристрій, 0 задач)', 'pcapp_auto_pay=false — автопродовження не зроблено'],
    bugs: ['Мертві pcapp_price_eur=22 / pcapp_price_uah=1100 в referral_settings — УІ їх більше не показує, ціни беруться з packages'],
    keyFiles: [
      { path: 'dashboard/api/pcapp_core.py', desc: 'Генерація рецепта (сервер), синхроніти з video_process' },
      { path: 'dashboard/api/main.py:1265', desc: 'Активація: kind=pcapp → users.pcapp_until += duration_months' },
      { path: 'dashboard/api/main.py:9615', desc: '/api/pcapp/price — читає МЕРТВІ ключі, не впливає на видачу' },
      { path: '_SESSIONS/pcapp/desktop/tauri/', desc: 'Rust-клієнт, збирається на Windows OWNER' },
    ]
  },
  {
    id: 'pl', emoji: '🎓', name: 'PlayLanguage', code: 'PL',
    account: '💎🅛 PL', color: '#60a5fa',
    desc: 'Telegram mini-app вивчення мов через Match/Test/Quiz/Practice/SRS',
    bootstrap: 'videobot-docs/_SESSIONS/pl/BOOTSTRAP.md',
    state: 'videobot-docs/_SESSIONS/pl/STATE.md',
    skill: '/resume pl',
    lastD: 'D-286 — Фікс туторіалу при зміні мови (2026-06-26)',
    next: ['i18n крипто-рядки DonateScreen ×8', 'Disk audit test-сервера', 'OWNER вводить USDT-адресу'],
    bugs: [],
    keyFiles: [
      { path: 'dashboard/miniapp/src/apps/playlanguage/PlayLanguageApp.jsx', desc: 'Shell: routing, tutorial, controls' },
      { path: 'dashboard/miniapp/src/apps/playlanguage/screens/HubScreen.jsx', desc: 'Головний хаб PL' },
      { path: 'dashboard/miniapp/src/apps/playlanguage/screens/DonateScreen.jsx', desc: 'Донат (USDT + card)' },
      { path: 'dashboard/api/main.py', desc: 'pl_* функції (спільний файл з Media!)' },
      { path: 'dashboard/miniapp/src/i18n/plScreens.js', desc: 'pl_t_* tutorial, pl_n_* new word' },
    ]
  }
];

// REVISION-20260819: топологію звірено живими командами на серверах.
// video-worker-1 (10.0.0.2) видалено 10.07.2026 — прибрано зі списку.
//
// LIVE-DEDICATED-20260819: нижче — ЛИШЕ опорні сервери, яких немає в таблиці
// dedicated_servers і які не змінюються роками. Виділені воркери (worker-5,
// netcup-1 і будь-які майбутні) НЕ хардкодяться — вони тягнуться з
// /api/dedicated/list, тому вкладка оновлюється сама після кнопок
// «Створити»/«Видалити» на сторінці Система.
const SERVERS = [
  {
    marker: '🟦', name: 'n8n-server', privateIp: '10.0.0.3', publicIp: '46.62.194.196',
    role: 'Redis • PostgreSQL • prod bot • NFS-сервер • 37 cron-агентів',
    services: ['telegram_bot (prod)', 'celery_worker (1, light)', 'alerts_callback_handler', 'broadcast_api', 'remediation_agent', 'watchdog'],
    ssh: 'ssh root@10.0.0.4 "ssh -i /root/.ssh/id_ed25519_sync_celery root@10.0.0.3 \'CMD\'"',
    color: '#818cf8'
  },
  {
    marker: '🟧', name: 'test-server', privateIp: '10.0.0.4', publicIp: '77.42.21.94',
    role: 'Dashboard • test bot • SSH entry point • celery (2)',
    services: ['celery_worker (2, heavy+light+batch)', 'telegram_bot (test)', 'fail2ban_api', 'sync_celery', 'watchdog',
               'Docker ×9: dashboard_api, dashboard_frontend, dashboard_miniapp, dashboard_prometheus, dashboard_grafana, dashboard_xtts, garage-ai-gateway, garage-ai-evolution, garage-ai-postgres'],
    ssh: 'ssh root@10.0.0.4',
    color: '#fb923c'
  },
  {
    marker: '🟩', name: 'staging-server', privateIp: '10.0.0.5', publicIp: '178.105.111.39',
    role: 'Celery worker (1 concurrent) + staging-стек у Docker',
    services: ['celery_worker (1, heavy+light)', 'sync_celery', 'Docker: staging_bot, staging_postgres, staging_redis'],
    ssh: 'ssh root@10.0.0.4 "ssh ...n8n... \'ssh root@10.0.0.5 CMD\'"',
    color: '#4ade80'
  },
];

const SYSTEM_TREE = {
  label: '📦 Система Katharsys', children: [
    {
      label: '🤖 Bot (n8n: /opt/video_bot/)', children: [
        { label: '🐍 bot/main.py', desc: 'Prod Telegram бот (743 КБ). md5:80c9aa44 (19.08.2026). _get_redis_password(), _reset_video_session()' },
        { label: '⚙️ celery_tasks.py', desc: 'Celery worker. _resolve_redis_pw() → env/DB. Broker: Redis db=0, Backend: db=1' },
        { label: '🎬 bot/video_process.py', desc: 'Обробка відео: хромакеї (auto-detect product), заставки (5 стилів), субтитри, постер-кадр' },
        { label: '📝 bot/subtitle_dynamic.py', desc: 'Динамічні субтитри' },
        { label: '🧠 bot/ai_analyze.py', desc: 'AI аналіз відео' },
        { label: '👁 watchdog.py', desc: 'Нагляд за процесами, алерти' },
        { label: '🔑 bot_tokens.env', desc: 'mode 600! 5 ботів. НЕ в git.' },
        { label: '📜 /usr/local/bin/sync_celery.sh', desc: 'Щогодини: celery_tasks.py, ai_analyze.py, database_pg.py, video_process.py, subtitle_dynamic.py → test, worker-5, staging. Джерело правди = n8n' },
      ]
    },
    {
      label: '🖥️ Dashboard API (test: /opt/dashboard/api/)', children: [
        { label: '🐍 main.py', desc: 'СПІЛЬНИЙ! Media (media_mono_*, /media/) + PL (pl_*) в одному файлі. media_mono=34.' },
        { label: '🎭 avatar_routes.py', desc: 'AVA API: /generate (async), /result/{id}, /script (mode=idea/rewrite), /trends, /voices' },
        { label: '🔗 miniapp_routes.py', desc: 'СПІЛЬНИЙ! /api/miniapp/avatar/*, /api/miniapp/pl/* роути' },
        { label: '📋 requirements.txt', desc: 'Python залежності' },
        { label: '🐳 Dockerfile', desc: 'Docker image dashboard-api' },
        { label: '🔧 post_recreate_fixes.sh', desc: 'Пост-recreate фікси (python3 symlink, fail2ban, prometheus)' },
      ]
    },
    {
      label: '📱 Dashboard Miniapp (React, /opt/dashboard/miniapp/)', children: [
        {
          label: '🎭 apps/mediaavatar/', children: [
            { label: 'Screens.jsx', desc: ':572 EMOTION_UI_DISABLED, :590-650 duration counter+AI rewrite+undo, CreateScreen головний' },
            { label: 'MediaAvatarApp.jsx', desc: 'Роутинг між екранами AVA' },
            { label: 'Forge.jsx', desc: 'Прогрес генерації (async polling)' },
            { label: 'Shatter.jsx', desc: 'Анімація результату' },
            { label: 'sound.js', desc: 'Звукові ефекти' },
            { label: 'styles.css', desc: 'CSS змінні --mav-*' },
          ]
        },
        {
          label: '🎓 apps/playlanguage/', children: [
            { label: 'PlayLanguageApp.jsx', desc: 'Shell: routing, tutorial steps, plControls (goTest/goQuiz/...)' },
            { label: 'screens/HubScreen.jsx', desc: 'Головний хаб: реф-суми fmtMoney, наші застосунки' },
            { label: 'screens/NewWordScreen.jsx', desc: 'Match — основна гра (пари слів)' },
            { label: 'screens/DonateScreen.jsx', desc: 'Донат: USDT TRC-20 + card реквізити' },
            { label: 'screens/LanguageSelectScreen.jsx', desc: 'Вибір мови навчання' },
            { label: 'screens/ActiveScreen.jsx', desc: 'Test/Quiz/Practice/Analytics вибір' },
          ]
        },
        {
          label: '🌍 i18n/', children: [
            { label: 'translations.js', desc: '8 мов (uk/ru/en/es/de/it/fr/pl). Core + mav_* (AVA) + pl_* (PL) в _plExtraI18n' },
            { label: 'plScreens.js', desc: 'pl_t_* (tutorial), pl_n_* (new word) ключі ×8 мов' },
            { label: 'LangContext.js', desc: 'useLang() хук, LanguageProvider' },
          ]
        },
      ]
    },
    {
      label: '🖥️ Dashboard Frontend (React admin, /opt/dashboard/frontend/)', children: [
        { label: 'App.js', desc: 'Routing + sidebar menu (drag & drop order)' },
        { label: 'pages/SystemPage.js', desc: 'Сервери: status, воркери on/off, Celery' },
        { label: 'pages/SettingsPage.js', desc: 'Налаштування: MediaMonoConfig + PL config' },
        { label: 'pages/SecretsPage.js', desc: 'Менеджер секретів (зашифровані)' },
        { label: 'pages/AvatarPage.js', desc: 'Адмін-панель AVA генерацій' },
        { label: 'pages/PlayLanguagePage.js', desc: 'PL адмін: words, tutorial toggle, pay config' },
        { label: 'pages/QueuePage.js', desc: 'Черга обробки відео (real-time)' },
        { label: 'pages/AIMemoryPage.js', desc: '🧠 Цей файл! Пам\'ять AI — проекти, дерева, сервери' },
      ]
    },
    {
      label: '🐳 Docker (test: /opt/dashboard/)', children: [
        { label: 'docker-compose.yml', desc: 'dashboard_api + dashboard_miniapp + dashboard_frontend контейнери' },
        { label: 'deploy.sh', desc: 'Деплой: git pull → build → docker cp → restart. Варіанти: api|frontend|both' },
      ]
    },
    {
      label: '📚 Документація (/home/cc_media/videobot-docs/)', children: [
        { label: '_SESSIONS/ANCHOR.md', desc: '🔑 Якір для нової сесії — вставити + /resume [project]' },
        { label: '_SESSIONS/ava/BOOTSTRAP.md', desc: 'AVA: SSH, файли, deploy, security' },
        { label: '_SESSIONS/ava/STATE.md', desc: 'AVA: поточний стан, баги, наступні задачі' },
        { label: '_SESSIONS/uniq/BOOTSTRAP.md', desc: 'UNIQ: bot, celery, deploy, idle-gate' },
        { label: '_SESSIONS/uniq/STATE.md', desc: 'UNIQ: поточний стан' },
        { label: '_SESSIONS/pl/BOOTSTRAP.md', desc: 'PL: mini-app, RED ZONE, tutorial' },
        { label: '_SESSIONS/pl/STATE.md', desc: 'PL: поточний стан' },
        { label: '_SESSIONS/SECURITY.md', desc: 'Security чеклісти за типом задачі' },
        { label: 'COORDINATION.md', desc: '🚦 Traffic light між Media і PL. Читати перед deploy спільного файлу!' },
        { label: 'WORKING_RULES.md', desc: '5 Заповідей + канони + чек-лист сесії' },
      ]
    },
    {
      label: '🗄️ База даних (PostgreSQL, n8n)', children: [
        { label: 'users', desc: 'Всі юзери: tg_id, lang, subscription, ad_countdown, soft_time_limit' },
        { label: 'processing_queue', desc: 'Черга відео: task_id, celery_id, status, worker, duration_sec' },
        { label: 'api_keys', desc: 'Секрети: redis_password, replicate_api_key, github_token...' },
        { label: 'packages', desc: 'Тарифи — 33 рядки. Поле kind: media (29) / pcapp (4). Ціна в EUR, ліміт на ДЕНЬ. ⚠ media_mono_packages НЕ ІСНУЄ' },
        { label: 'packages → pcapp', desc: 'PC Unlimited: 30/70/120/200 € за 1/3/6/12 міс. Це ДЖЕРЕЛО ПРАВДИ для видачі підписки' },
        { label: 'media_mono_payments', desc: 'Інтенти Monobank (unique-amount). UNIQUE(ext_tx_id) = 1 tx → 1 інтент' },
        { label: 'dedicated_servers', desc: 'Виділені воркери: worker-5 активний, netcup-1 до 05.09.2026, 7 видалених' },
        { label: 'incidents', desc: 'Журнал автолікування remediation_agent — 50 записів' },
        { label: 'pcapp_devices / pcapp_jobs / pcapp_pairing / pcapp_uniq_log', desc: 'Autopilot Studio. Зараз: 1 пристрій, 0 задач' },
        { label: 'referral_settings', desc: 'Реферальна config + onboarding_lesson_enabled (PL)' },
        { label: 'user_words (PL)', desc: 'Слова юзерів: mastery 1-5★, SRS дати' },
        { label: 'app_playlanguage_* (PL)', desc: 'PL мета-дані: tutorial, unlocks, lesson progress' },
      ]
    },
    {
      label: '🔴 Redis (n8n, порт 6379)', children: [
        { label: 'db=0', desc: 'Celery broker (черга задач)' },
        { label: 'db=1', desc: 'Celery result backend' },
        { label: 'db=2', desc: 'Direct redis_client (бот)' },
        { label: 'requirepass', desc: 'Пароль в /etc/redis/redis.conf. Ротовано D-292 (2026-06-29)' },
      ]
    },
  ]
};

const BOT_MENU_TREE = {
  label: '🤖 Telegram Bot (@media_2026_bot)', children: [
    {
      label: '/start → Вітання + вибір мови', desc: 'Перший запуск або /start повторний. Вибір мови інтерфейсу (8 мов: uk/ru/en/es/de/it/fr/pl)',
      children: [
        {
          label: '🏠 Головне меню', children: [
            {
              label: '🎬 Обробити відео', desc: 'Завантажити відео для унікалізації', children: [
                { label: '📤 Надіслати відео', desc: 'MP4/MOV/HEVC з галереї або переслане (переслане — повільніше через Telegram CDN)' },
                { label: '📢 Реклама', desc: 'Вибір відліку реклами: Миттєва (0с) / Стандартна (5с) / Без. persist у users.ad_countdown' },
                { label: '💬 Субтитри', desc: 'ТАК / НІ / Без субтитрів. Якщо є реклама — окреме питання про субтитри реклами' },
                {
                  label: '🎭 Хромакеї', desc: 'Вибір файлів + позиція. До 3 слотів (можна повторювати той самий)', children: [
                    { label: '📚 Бібліотека хромакеїв', desc: 'Збережені хромакеї юзера (users/<tg_id>/chromakeys/). Показуються першими.' },
                    { label: '📤 Новий хромакей', desc: 'Завантажити PNG/WebM з зеленим екраном' },
                    { label: '📍 Позиція A/B/C/D/E', desc: 'Per-item позиція після кожного вибору. Рівномірний розподіл по тривалості відео.' },
                  ]
                },
                {
                  label: '🖼️ Оверлеї', desc: 'Фото/відео накладки (без хромакея)', children: [
                    { label: '📤 Завантажити оверлей', desc: 'Фото або відео-файл' },
                    { label: '📍 Позиція A/B/C/D/E', desc: 'Per-item позиція. Рівномірний розподіл по тривалості.' },
                    { label: '🔊 Звук оверлея', desc: 'ON/OFF на кожен відео-оверлей окремо' },
                  ]
                },
                {
                  label: '🎨 Стиль заставки', desc: '5 стилів постера на першому кадрі', children: [
                    { label: 'GRADIENT', desc: 'Градієнтний фон' },
                    { label: '3D', desc: '3D-ефект тексту' },
                    { label: 'CARTOON', desc: 'Мультяшний стиль' },
                    { label: 'GLASS', desc: 'Скляний ефект' },
                    { label: 'NEON', desc: 'Неонове світіння' },
                  ]
                },
                {
                  label: '⚙️ Проф-режим (Профі)', desc: 'Додаткові налаштування для досвідчених', children: [
                    { label: '📏 Max subtitle lines', desc: '1 / 2 / 3 / ∞ рядків субтитрів одночасно' },
                    { label: '📍 Позиція субтитрів', desc: 'A/B/C/D/E + CT (center-top) / CB (center-bottom)' },
                  ]
                },
                { label: '▶️ Генерувати (N версій)', desc: 'Задача → Celery queue → worker (heavy/light) → результат. Split на частини якщо >3хв.' },
                {
                  label: '✅ Результат', desc: 'Готове відео. Підтримка N версій.', children: [
                    { label: '✅ OK', desc: 'Отримати відео, перейти до наступної версії' },
                    { label: '🏁 Завершити', desc: 'Пропустити поточну версію (перейти до наступної)' },
                    { label: '✉️ Помилка', desc: 'Алерт OWNER + юзеру пояснення + auto-reset сесії' },
                  ]
                },
              ]
            },
            {
              label: '📦 Пакети', desc: 'Придбати підписку. Оплата через Monobank.', children: [
                { label: '🆓 Trial', desc: 'Пробний безкоштовний доступ (обмежений)' },
                { label: '📦 Базовий / Стандарт / Про', desc: 'Плани підписок у EUR. Авто-конвертація в UAH/USD. PackagesPage.js.' },
                { label: '👑 Founders Club', desc: 'Спеціальний план для засновників (/pay endpoint, D-221)' },
                { label: '💳 Оплата Monobank', desc: 'Посилання → юзер платить → OWNER підтверджує у дашборді → квитанція' },
                { label: '✅ Підтвердження адміном', desc: 'Dashboard ReceiptsPage: підтвердити/відхилити. Монобанк webhook або ручне.' },
              ]
            },
            {
              label: '👤 Мій профіль', children: [
                { label: '📊 Статистика', desc: 'Кількість оброблених відео, залишок підписки (дд:гг:хв)' },
                { label: '💳 Підписка', desc: 'Поточний план, дата закінчення, trial countdown' },
                { label: '⏱️ Таймер реклами', desc: 'Вибір відліку реклами: Миттєва / Стандартна / Без. Persist у users.ad_countdown.' },
                { label: '🌐 Змінити мову', desc: 'Мова інтерфейсу (uk/ru/en/es/de/it/fr/pl)' },
              ]
            },
            {
              label: '💰 Реф-програма', desc: 'Реферальна система L1→L2→L3→L4', children: [
                { label: '🔗 Моє посилання', desc: 'Унікальне реф-посилання для поширення' },
                { label: '📊 Мої реферали', desc: 'Дерево L1/L2/L3 + суми нарахувань. Hub → Баланс → деталі.' },
                { label: '💵 Баланс і виведення', desc: '14-денна заморозка → confirmed → виплата. Мін. €0.50. Freezed countdown.' },
                { label: '🏆 Акції / Конкурси', desc: 'Бонусний множник ×N за платіж під час акції. Показ у Margin Guard.' },
              ]
            },
            {
              label: '📱 Хаб (Mini-App)', desc: 'Відкриває Telegram WebApp (mini-app) на test:8001', children: [
                {
                  label: '🎭 MediaAvatar (AVA)', desc: 'AI-відео з аватаром і голосом', children: [
                    { label: '📝 CreateScreen', desc: 'Тема/ідея, текст скрипту, мова, тон, голос. Авто-оцінка тривалості.' },
                    { label: '📈 Duration Counter', desc: 'Зелений ✓ (влазить) / Червоний ⚠+Xс (перевищення). WPS per-lang.' },
                    { label: '✂ Обрізати', desc: 'truncateToSecs() — обрізати до цільової тривалості' },
                    { label: '✨ ШІ перепише', desc: 'POST /avatar/script mode=idea. Зберігає prevText для Повернути.' },
                    { label: '↩ Повернути', desc: 'Повернути попередній текст (prevText state)' },
                    { label: '🔄 Нова варіація', desc: 'Ще одна версія скрипту від ШІ' },
                    { label: '🎤 Вибір голосу', desc: 'Завантажити зразок (voice cloning) або готовий TTS-голос' },
                    { label: '⚙️ Forge', desc: 'Async: POST /generate → job_id → polling /result/{id} кожні 5с до 10хв' },
                    { label: '🎬 Результат', desc: 'Перегляд + завантаження. «Закрити/чекати у фоні» — overlayDismissed.' },
                  ]
                },
                {
                  label: '🎓 PlayLanguage (PL)', desc: 'Вивчення іноземних мов через SRS', children: [
                    { label: '🌐 Вибір мови навчання', desc: '6 мов: en(British)/en_US(American)/de/fr/it/es/pl. + 8 рідних мов.' },
                    { label: '🎮 Match', desc: 'Знайди пари слів → SRS → Knowledge Base. nonbeginner_lower_mix_pct% легших слів.' },
                    { label: '📝 Test (Column)', desc: 'Колонковий тест: перетягни або вибери переклад. Зображення слова при помилці.' },
                    { label: '❓ Quiz', desc: '4-варіанти відповіді → mastery +1/-1 → 5★ → Knowledge Base. Quiz bar = mastery поточного слова.' },
                    { label: '🎧 Practice (TTS)', desc: 'LLM-речення → TTS → підсвітка слів (ontimeupdate). Tap → переклад (vocab або LLM).' },
                    { label: '📊 Analytics', desc: 'Прогрес по активностях, mastery статистика, слів в КБ' },
                    { label: '🎓 Урок-1 (Онбординг)', desc: '6 кроків: Match→Test→Quiz→Іспит(7★)→Practice→Analytics. Kill-switch: onboarding_lesson_enabled.' },
                    { label: '💰 Donate', desc: 'USDT TRC-20 адреса + card реквізити. pay_show_crypto toggle.' },
                    { label: '❓ Підтримка', desc: 'Форма звернення до команди PL' },
                  ]
                },
                { label: '💰 Баланс / Реф-дерево', desc: 'Реферальна програма: L1-L4 дерево, нарахування з квитанціями, frozen balance countdown' },
                { label: '📋 Квитанції (Receipts)', desc: 'Список платежів Monobank + статус підтвердження + countdown до закінчення' },
                { label: '⚙️ Налаштування', desc: 'MediaMonoConfig (media) + PL config (donate, mова бота)' },
              ]
            },
            {
              label: '💬 Підтримка', children: [
                { label: '❓ FAQ', desc: 'Часті запитання автовідповідь' },
                { label: '✉️ Написати', desc: 'Звернення → forward до admin group thread 1107' },
              ]
            },
          ]
        }
      ]
    },
  ]
};

const SKILLS = [
  {
    cmd: '/resume ava', desc: 'Завантажити контекст MediaAvatar (BOOTSTRAP + STATE)',
    steps: ['Читає _SESSIONS/ava/BOOTSTRAP.md', 'Читає _SESSIONS/ava/STATE.md', 'Перевіряє COORDINATION.md', 'Виводить: останній D, сервери, наступна задача']
  },
  {
    cmd: '/resume uniq', desc: 'Завантажити контекст UNIQ Bot',
    steps: ['Читає _SESSIONS/uniq/BOOTSTRAP.md', 'Читає _SESSIONS/uniq/STATE.md', 'Виводить стан + наступні кроки']
  },
  {
    cmd: '/resume pl', desc: 'Завантажити контекст PlayLanguage',
    steps: ['Читає _SESSIONS/pl/BOOTSTRAP.md', 'Читає _SESSIONS/pl/STATE.md', 'Виводить стан + активні баги']
  },
  {
    cmd: '/onboard', desc: 'Першочергове налаштування нової машини/акаунта',
    steps: ['Читає ONBOARDING.md', 'Заповнює memory-файли', 'Перевіряє SSH доступ', 'Перевіряє GitHub access']
  },
];

const COMMANDMENTS = [
  { num: '1', name: 'БЕЗПЕКА', desc: 'Snapshot перед ризиком. Оцінка % ризику (🟢0-5% 🟡5-15% 🔴15%+). Шлях відкату.' },
  { num: '2', name: 'ЗАВЕРШЕННЯ', desc: 'Доводити до кінця. Не перескакувати. Не заглушки.' },
  { num: '3', name: 'НАДІЙНІСТЬ', desc: 'Будь-яка корисна підстраховка обов\'язкова.' },
  { num: '4', name: 'ДЕЦИДНІСТЬ', desc: 'Приймати рішення без затягування.' },
  { num: '5', name: 'ВЕРИФІКАЦІЯ', desc: 'Звіряти реальний стан перед дією. Не покладатись на пам\'ять.' },
];

// ─── Парсер STATE.md ───────────────────────────────────────────────────────

function parseStateFile(text) {
  if (!text || text === 'файл не знайдено') return null;
  const lines = text.split('\n');
  let section = null;
  const bugs = [], next = [];
  let lastD = null;
  for (const line of lines) {
    if (line.startsWith('## 🔴')) { section = 'bugs'; continue; }
    if (line.startsWith('## ✅')) { section = 'done'; continue; }
    if (line.startsWith('## ⏳')) { section = 'next'; continue; }
    if (line.startsWith('## '))  { section = null;   continue; }
    if (section === 'bugs') {
      const t = line.replace(/^[-*]\s*/, '').trim();
      if (t && !t.startsWith('_(')) bugs.push(t);
    }
    if (section === 'done' && lastD === null) {
      const m = line.match(/^\*\*([^*]+)\*\*(.*)/);
      if (m) lastD = (m[1] + m[2]).trim();
    }
    if (section === 'next') {
      const m = line.match(/^(\d+)\.\s+(.+)/);
      if (m && !m[2].trim().startsWith('~~')) {
        const clean = m[2].replace(/\*\*/g, '').replace(/~~[^~]*~~/g, '').trim();
        if (clean) next.push(clean);
      }
    }
  }
  return { lastD, bugs, next };
}

// ─── Компоненти ────────────────────────────────────────────────────────────

function CopyBtn({ text, style = {} }) {
  const [ok, setOk] = useState(false);
  const copy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setOk(true);
      setTimeout(() => setOk(false), 1800);
    }).catch(() => {
      const ta = document.createElement('textarea');
      ta.value = text; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch(e) {}
      document.body.removeChild(ta);
      setOk(true); setTimeout(() => setOk(false), 1800);
    });
  };
  return (
    <button onClick={copy} style={{
      background: ok ? 'rgba(52,211,153,.2)' : 'rgba(255,255,255,.07)',
      border: `1px solid ${ok ? '#34d399' : 'rgba(255,255,255,.15)'}`,
      color: ok ? '#34d399' : '#94a3b8', borderRadius: 6,
      padding: '3px 10px', fontSize: 11, cursor: 'pointer', transition: 'all .2s',
      whiteSpace: 'nowrap', ...style,
    }}>
      {ok ? '✓ Скопійовано' : '⎘ Копіювати'}
    </button>
  );
}

const s = {
  page: { padding: '24px', maxWidth: 1200, margin: '0 auto', color: '#e2e8f0', fontFamily: 'inherit' },
  header: { marginBottom: 24 },
  title: { fontSize: 26, fontWeight: 700, color: '#f1f5f9', display: 'flex', alignItems: 'center', gap: 10 },
  subtitle: { fontSize: 13, color: '#94a3b8', marginTop: 4 },
  tabs: { display: 'flex', gap: 8, marginBottom: 24, flexWrap: 'wrap' },
  tab: (active, color) => ({
    padding: '8px 16px', borderRadius: 20, border: `1px solid ${active ? color : 'rgba(255,255,255,.15)'}`,
    background: active ? `${color}22` : 'rgba(255,255,255,.05)', color: active ? color : '#94a3b8',
    cursor: 'pointer', fontSize: 13, fontWeight: active ? 600 : 400, transition: 'all .2s'
  }),
  card: { background: 'rgba(255,255,255,.05)', borderRadius: 12, padding: 20, marginBottom: 16 },
  projectCard: (color) => ({ ...s.card, borderLeft: `3px solid ${color}` }),
  badge: (color) => ({ display: 'inline-block', padding: '2px 8px', borderRadius: 12, background: `${color}22`, color, fontSize: 11, fontWeight: 600 }),
  h3: { fontSize: 15, fontWeight: 600, color: '#f1f5f9', marginBottom: 10 },
  h4: { fontSize: 13, fontWeight: 600, color: '#cbd5e1', marginBottom: 6 },
  code: { background: 'rgba(0,0,0,.3)', borderRadius: 6, padding: '2px 8px', fontFamily: 'monospace', fontSize: 12, color: '#86efac' },
  codeBlock: { background: 'rgba(0,0,0,.4)', borderRadius: 8, padding: 12, fontFamily: 'monospace', fontSize: 12, color: '#86efac', overflow: 'auto', marginTop: 8, whiteSpace: 'pre' },
  tag: (c) => ({ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '2px 10px', borderRadius: 20, background: `${c}15`, color: c, border: `1px solid ${c}30`, fontSize: 11, marginRight: 4, marginBottom: 4 }),
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16 },
  serverCard: (color) => ({ ...s.card, borderTop: `3px solid ${color}` }),
  syncBanner: { background: 'rgba(251,191,36,.1)', border: '1px solid rgba(251,191,36,.3)', borderRadius: 8, padding: '10px 16px', marginBottom: 20, fontSize: 12, color: '#fbbf24' },
};

function TreeNode({ node, depth = 0 }) {
  const [open, setOpen] = useState(depth < 2);
  const hasChildren = node.children && node.children.length > 0;
  return (
    <div style={{ marginLeft: depth * 16 }}>
      <div
        onClick={() => hasChildren && setOpen(!open)}
        style={{ display: 'flex', alignItems: 'flex-start', gap: 6, padding: '5px 8px', borderRadius: 6, cursor: hasChildren ? 'pointer' : 'default', background: open && hasChildren ? 'rgba(255,255,255,.04)' : 'transparent', transition: 'background .15s', marginBottom: 2 }}
      >
        <span style={{ fontSize: 11, color: '#64748b', minWidth: 14, marginTop: 2 }}>
          {hasChildren ? (open ? '▼' : '▶') : '·'}
        </span>
        <div>
          <span style={{ fontSize: 13, color: hasChildren ? '#e2e8f0' : '#94a3b8', fontWeight: hasChildren ? 500 : 400 }}>{node.label}</span>
          {node.desc && <div style={{ fontSize: 11, color: '#64748b', marginTop: 2, lineHeight: 1.4 }}>{node.desc}</div>}
          {node.lines && <span style={{ ...s.code, marginLeft: 6, fontSize: 10 }}>{node.lines}</span>}
        </div>
      </div>
      {open && hasChildren && node.children.map((child, i) => <TreeNode key={i} node={child} depth={depth + 1} />)}
    </div>
  );
}

function ProjectCard({ proj, live }) {
  const [expanded, setExpanded] = useState(false);
  const lastD = (live && live.lastD) ? live.lastD : proj.lastD;
  const bugs  = (live && live.bugs  != null) ? live.bugs  : proj.bugs;
  const next  = (live && live.next  && live.next.length > 0) ? live.next : proj.next;
  return (
    <div style={s.projectCard(proj.color)}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', cursor: 'pointer' }} onClick={() => setExpanded(!expanded)}>
        <div>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#f1f5f9', marginBottom: 4 }}>
            {proj.emoji} {proj.name} <span style={s.badge(proj.color)}>{proj.code}</span>
            {live && <span style={{ fontSize: 10, color: '#4ade80', marginLeft: 8, fontWeight: 400 }}>● live</span>}
          </div>
          <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 8 }}>{proj.desc}</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 12, color: '#64748b' }}>
              Акаунт: <span style={{ color: '#cbd5e1' }}>{proj.account}</span>
              &nbsp;·&nbsp;Skill: <span style={s.code}>{proj.skill}</span>
            </span>
            <CopyBtn text={proj.skill} />
          </div>
        </div>
        <span style={{ fontSize: 18, color: '#64748b' }}>{expanded ? '▲' : '▼'}</span>
      </div>

      <div style={{ marginTop: 12 }}>
        <div style={{ fontSize: 12, color: '#64748b' }}>Останнє:</div>
        <div style={{ fontSize: 13, color: '#86efac', marginBottom: 8 }}>✅ {lastD}</div>

        {bugs.length > 0 && (
          <div style={{ marginBottom: 8 }}>
            {bugs.map((b, i) => <div key={i} style={{ fontSize: 12, color: '#f87171' }}>{b}</div>)}
          </div>
        )}

        <div style={{ fontSize: 12, color: '#64748b', marginBottom: 4 }}>Наступні задачі:</div>
        {next.length > 0
          ? next.map((t, i) => <div key={i} style={{ fontSize: 12, color: '#cbd5e1', paddingLeft: 12 }}>[ ] {t}</div>)
          : <div style={{ fontSize: 12, color: '#64748b', paddingLeft: 12 }}>— немає активних задач</div>}
      </div>

      {expanded && (
        <div style={{ marginTop: 16, borderTop: '1px solid rgba(255,255,255,.08)', paddingTop: 16 }}>
          <div style={s.h4}>📁 Ключові файли</div>
          {proj.keyFiles.map((f, i) => (
            <div key={i} style={{ marginBottom: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                <code style={s.code}>{f.path}</code>
                <CopyBtn text={f.path} />
                {f.lines && <span style={{ fontSize: 10, color: '#64748b' }}>{f.lines}</span>}
              </div>
              <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2, paddingLeft: 4 }}>{f.desc}</div>
            </div>
          ))}
          <div style={{ marginTop: 12 }}>
            <div style={s.h4}>📖 Session файли</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
              <span style={s.code}>{proj.bootstrap}</span>
              <CopyBtn text={proj.bootstrap} />
              <span style={{ fontSize: 11, color: '#64748b' }}>— архітектура</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={s.code}>{proj.state}</span>
              <CopyBtn text={proj.state} />
              <span style={{ fontSize: 11, color: '#64748b' }}>— поточний стан</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// LIVE-DEDICATED-20260819: рядок dedicated_servers -> формат картки сервера.
// mode/queue/concurrency беремо як є з БД, щоб картка не могла розійтись
// з реальним налаштуванням воркера.
function _dedToCard(d) {
  const isWg = String(d.private_ip || '').startsWith('10.8.0.');
  const svc = ['celery_worker (' + (d.concurrency || '?') + '): ' + (d.queue || '—')];
  if (d.mode && d.mode !== 'all') svc.push('режим: ' + d.mode);
  if (d.users) svc.push('прив’язано юзерів: ' + d.users);
  if (!isWg) svc.push('sync_celery');
  return {
    marker: isWg ? '⚪' : '🟨',
    name: d.name,
    role: (d.stype ? d.stype + ' · ' : '') + (d.price || '') + (d.disk_pct ? ' · диск ' + d.disk_pct + '%' : ''),
    privateIp: d.private_ip || '—',
    publicIp: isWg ? 'через WireGuard' : (d.public_ip || '—'),
    services: svc,
    ssh: isWg
      ? 'ssh root@10.0.0.4 "ssh root@10.0.0.3 \'ssh root@' + d.private_ip + '\'"'
      : 'ssh root@10.0.0.4 "ssh root@' + d.private_ip + ' \'CMD\'"',
    color: isWg ? '#9ca3af' : '#facc15',
  };
}

function ServerCard({ server }) {
  return (
    <div style={s.serverCard(server.color)}>
      <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>
        {server.marker} {server.name}
      </div>
      <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 8 }}>{server.role}</div>
      <div style={{ fontSize: 11, marginBottom: 8 }}>
        <span style={s.tag('#818cf8')}>🔒 {server.privateIp}</span>
        <span style={s.tag('#34d399')}>🌐 {server.publicIp}</span>
      </div>
      <div style={s.h4}>Сервіси</div>
      {server.services.map((sv, i) => (
        <div key={i} style={{ fontSize: 11, color: '#94a3b8', paddingLeft: 8 }}>· {sv}</div>
      ))}
      <div style={{ marginTop: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
          <div style={s.h4}>SSH</div>
          <CopyBtn text={server.ssh} />
        </div>
        <div style={{ ...s.codeBlock, fontSize: 10, padding: '6px 10px' }}>{server.ssh}</div>
      </div>
    </div>
  );
}

// D-297 п.3: Live server card (shows real-time status from /api/servers/live-status)
function LiveServerCard({ data }) {
  const COLOR = { n8n: '#818cf8', test: '#fb923c', worker1: '#facc15', staging: '#4ade80' };
  const clr = COLOR[data.id] || '#94a3b8';
  const diskClr = !data.disk_pct ? '#64748b'
    : data.disk_pct >= 90 ? '#f87171'
    : data.disk_pct >= 80 ? '#fbbf24'
    : '#4ade80';
  const allOk = data.online && data.services.every(s => s.ok);
  return (
    <div style={s.serverCard(clr)}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
        <div style={{ fontSize: 16, fontWeight: 700 }}>{data.emoji} {data.name}</div>
        <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 6,
          background: allOk ? 'rgba(74,222,128,.15)' : 'rgba(248,113,113,.15)',
          color: allOk ? '#4ade80' : '#f87171', border: `1px solid ${allOk ? 'rgba(74,222,128,.3)' : 'rgba(248,113,113,.3)'}` }}>
          {allOk ? '✅ OK' : '⚠️ УВАГА'}
        </span>
      </div>
      <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 8 }}>🔒 {data.ip} · {data.ping_ms}ms</div>
      {data.disk_pct !== null && (
        <div style={{ marginBottom: 8 }}>
          <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 3 }}>💾 Диск</div>
          <div style={{ background: 'rgba(0,0,0,.25)', borderRadius: 4, height: 6, overflow: 'hidden' }}>
            <div style={{ width: `${data.disk_pct}%`, background: diskClr, height: '100%', borderRadius: 4, transition: 'width .4s' }} />
          </div>
          <div style={{ fontSize: 11, color: diskClr, marginTop: 2 }}>{data.disk_pct}% використано</div>
        </div>
      )}
      {data.redis_ok !== null && (
        <div style={{ fontSize: 11, marginBottom: 6,
          color: data.redis_ok ? '#4ade80' : '#f87171' }}>
          {data.redis_ok ? '🟢 Redis: PONG' : '🔴 Redis: FAIL'}
        </div>
      )}
      <div style={s.h4}>Сервіси</div>
      {data.services.map((sv, i) => (
        <div key={i} style={{ fontSize: 11, paddingLeft: 8, marginBottom: 1,
          color: sv.ok ? '#86efac' : '#fca5a5' }}>
          {sv.ok ? '●' : '○'} {sv.name} <span style={{ opacity: .7 }}>{sv.status}</span>
        </div>
      ))}
    </div>
  );
}

function SkillCard({ skill }) {
  return (
    <div style={s.card}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
        <span style={{ ...s.code, fontSize: 14, fontWeight: 700 }}>{skill.cmd}</span>
        <CopyBtn text={skill.cmd} />
      </div>
      <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 10 }}>{skill.desc}</div>
      <div style={s.h4}>Що робить:</div>
      {skill.steps.map((step, i) => (
        <div key={i} style={{ fontSize: 12, color: '#cbd5e1', paddingLeft: 8, marginBottom: 2 }}>{i + 1}. {step}</div>
      ))}
    </div>
  );
}

// ─── Аварійний HTML-експорт ────────────────────────────────────────────────

// EMERGENCY-LIVE-20260819: dedRows — живі виділені воркери з /api/dedicated/list.
function buildEmergencyHTML(dateStr, stateData, secretsBlobs, dedRows) {
  const sd = stateData || {};
  const sb = Array.isArray(secretsBlobs) ? secretsBlobs : [];
  const e = (s) => String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  const cb = (txt) => `<div class="cb"><pre>${e(txt)}</pre><button class="cp" onclick="cp(this,${JSON.stringify(txt)})">&#x2398; Копіювати</button></div>`;

  const projCards = [
    {id:'ava',  em:'🎭', nm:'AVA — MediaAvatar',          cl:'var(--ac2, #a78bfa)'},
    {id:'uniq', em:'🎬', nm:'UNIQ — Media Uniqueizer Bot', cl:'#34d399'},
    {id:'pl',   em:'🎓', nm:'PL — PlayLanguage',           cl:'#60a5fa'},
  ].map(p=>`<div class="pc" style="border-left:3px solid ${p.cl}"><div class="pt">${p.em} ${e(p.nm)}</div>
    <div class="ht">Skill-команда (Claude Code):</div>${cb('/resume '+p.id)}
    <div class="ht" style="margin-top:8px">Якщо skills не працюють — вставити в Claude:</div>
    ${cb('Продовжуй проект '+p.id.toUpperCase()+'.\nПрочитай:\n1. /home/cc_media/videobot-docs/_SESSIONS/'+p.id+'/BOOTSTRAP.md\n2. /home/cc_media/videobot-docs/_SESSIONS/'+p.id+'/STATE.md\n3. /home/cc_media/videobot-docs/COORDINATION.md\n\nПотім: останній D-номер, стан серверів, наступна задача.')}
  </div>`).join('');

  // REVISION2-20260819: топологія звірена живими командами.
  // video-worker-1 (10.0.0.2) ВИДАЛЕНО 10.07.2026 — прибрано, щоб при аварійній
  // відбудові ніхто не шукав неіснуючий сервер.
  // Опорні сервери (їх немає в dedicated_servers і вони не змінюються роками)
  const _coreSrv = [
    {m:'🟦',n:'n8n-server',     pr:'10.0.0.3',pu:'46.62.194.196', r:'Redis · PostgreSQL · prod bot · NFS · 37 cron',cl:'#818cf8'},
    {m:'🟧',n:'test-server',    pr:'10.0.0.4',pu:'77.42.21.94',  r:'Dashboard (9 контейнерів) · SSH entry · celery (2)',   cl:'#fb923c'},
    {m:'🟩',n:'staging-server', pr:'10.0.0.5',pu:'178.105.111.39',r:'Celery worker (1 concurrent)',      cl:'#4ade80'},
  ];
  // Живі виділені воркери. Якщо їх не передали — список нижче буде лише опорний,
  // і документ про це ЧЕСНО попередить (див. _dedNote).
  const _liveSrv = (Array.isArray(dedRows) ? dedRows : []).filter(d => d.status === 'active').map(d => {
    const wg = String(d.private_ip || '').startsWith('10.8.0.');
    return {
      m: wg ? '⚪' : '🟨',
      n: d.name,
      pr: (d.private_ip || '—') + (wg ? ' (WG)' : ''),
      pu: wg ? 'через WireGuard' : '—',
      r: 'Виділений воркер · ' + (d.stype || '?') + ' · concurrency=' + (d.concurrency || '?') + ' · ' + (d.queue || ''),
      cl: wg ? '#9ca3af' : '#facc15',
    };
  });
  const _dedNote = Array.isArray(dedRows)
    ? ('Виділені воркери взято з бази на момент вивантаження: ' + (_liveSrv.length || 0) + ' активних.')
    : '⚠️ Виділені воркери НЕ вдалося прочитати з бази — нижче лише опорні сервери. Звір список вручну: SELECT name,private_ip,queue,concurrency FROM dedicated_servers WHERE status=\'active\';';
  const srvCards = [..._coreSrv, ..._liveSrv].map(s=>`<div class="sc" style="border-top:3px solid ${s.cl}"><div class="sn">${s.m} ${e(s.n)}</div><div class="sr">${e(s.r)}</div><div class="si"><span style="color:#818cf8">🔒 ${s.pr}</span> · <span style="color:#34d399">🌐 ${s.pu}</span></div></div>`).join('');

  const sshCmds = [
    ['1. Вхід на test-сервер (точка входу)','ssh root@10.0.0.4'],
    ['2. Стан сервісів n8n','ssh root@10.0.0.4 "ssh -i /root/.ssh/id_ed25519_sync_celery root@10.0.0.3 \'supervisorctl status\'"'],
    ['3. Celery workers (зараз 5 nodes; з 05.09.2026 — 4, netcup-1 відключається)','ssh root@10.0.0.4 "ssh -i /root/.ssh/id_ed25519_sync_celery root@10.0.0.3 \'cd /opt/video_bot && celery -A celery_tasks inspect ping -t 5\'"'],
    ['4. Черга (0 перед рестартом)','ssh root@10.0.0.4 "ssh -i /root/.ssh/id_ed25519_sync_celery root@10.0.0.3 \'redis-cli LLEN celery\'"'],
    ['5. Переглянути стан AVA','cat /home/cc_media/videobot-docs/_SESSIONS/ava/STATE.md'],
    ['6. Переглянути стан UNIQ','cat /home/cc_media/videobot-docs/_SESSIONS/uniq/STATE.md'],
    ['7. Переглянути стан PL','cat /home/cc_media/videobot-docs/_SESSIONS/pl/STATE.md'],
    ['8. Останні коміти','git -C /home/cc_media/videobot-docs log --oneline -10'],
    ['9. Рестарт Dashboard','ssh root@10.0.0.4 "docker restart dashboard_api dashboard_miniapp dashboard_frontend"'],
  ].map(([l,t])=>`<div class="eb"><div class="el">${e(l)}</div>${cb(t)}</div>`).join('');

  const secretRows = [
    ['Redis password','PostgreSQL → api_keys WHERE service=\'redis_password\''],
    ['Replicate API key','PostgreSQL → api_keys WHERE service=\'replicate_api_key\''],
    ['Telegram bot tokens','/opt/video_bot/bot_tokens.env (mode 600, n8n-server)'],
    ['Hetzner token','/root/.hcloud_token (mode 600, n8n-server)'],
    ['GitHub SSH key','~/.ssh/id_ed25519_github (цей ПК)'],
    ['Dashboard master pwd','OWNER зберігає фізично (не в коді/чаті)'],
    ['PostgreSQL','10.0.0.3:5432, user: videobot, db: videobot'],
  ].map(([k,v])=>`<tr><td>${e(k)}</td><td>${e(v)}</td></tr>`).join('');

  const fileRows = [
    ['_SESSIONS/ANCHOR.md','Якір — тексти для вставки у нову сесію'],
    ['_SESSIONS/ava/STATE.md','AVA: поточний стан, баги, наступне'],
    ['_SESSIONS/uniq/STATE.md','UNIQ: поточний стан'],
    ['_SESSIONS/pl/STATE.md','PL: поточний стан'],
    ['COORDINATION.md','Traffic light між Media і PL'],
    ['WORKING_RULES.md','5 Заповідей + усі правила'],
    ['.claude/commands/resume.md','Skill /resume'],
    ['.claude/commands/onboard.md','Skill /onboard'],
  ].map(([p,d])=>`<tr><td><code>${e(p)}</code></td><td>${e(d)}</td></tr>`).join('');

  const css = `:root{--bg:#0f0f1a;--bg2:#1a1a2e;--bd:#ffffff18;--tx:#e2e8f0;--mu:#64748b}
*{box-sizing:border-box;margin:0;padding:0}body{background:var(--bg);color:var(--tx);font-family:system-ui,sans-serif;line-height:1.5}
.page{max-width:960px;margin:0 auto;padding:24px}
.topbar{background:linear-gradient(135deg,#1e1b4b,#0f172a);border:1px solid var(--ac2, #a78bfa)55;border-radius:14px;padding:20px 24px;margin-bottom:20px;display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:12px}
.toptitle{font-size:22px;font-weight:800;color:#fff}.topmeta{font-size:12px;color:var(--mu);margin-top:4px}
.prbtn{background:rgba(251,191,36,.15);border:1px solid #fbbf2466;color:#fbbf24;border-radius:8px;padding:8px 16px;cursor:pointer;font-size:13px;font-weight:600}
.warn{background:rgba(248,113,113,.08);border:1px solid rgba(248,113,113,.3);border-radius:10px;padding:12px 16px;margin-bottom:18px;font-size:13px;color:#fca5a5}
h2{font-size:15px;font-weight:700;color:#f1f5f9;margin-bottom:12px;padding-bottom:8px;border-bottom:1px solid var(--bd)}
.sec{background:var(--bg2);border:1px solid var(--bd);border-radius:12px;padding:20px;margin-bottom:16px}
.pc{background:rgba(0,0,0,.3);border-radius:10px;padding:14px;margin-bottom:10px}
.pt{font-size:14px;font-weight:700;color:#f1f5f9;margin-bottom:8px}.ht{font-size:11px;color:var(--mu);margin:5px 0 3px}
.cb{position:relative;margin-bottom:4px}
pre{background:rgba(0,0,0,.5);border:1px solid var(--bd);border-radius:8px;padding:10px 90px 10px 12px;font-family:monospace;font-size:12px;color:#86efac;white-space:pre-wrap;word-break:break-all}
.cp{position:absolute;top:6px;right:6px;background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.15);color:#94a3b8;border-radius:6px;padding:3px 10px;font-size:11px;cursor:pointer;transition:all .2s}
.cp:hover,.cp.ok{background:rgba(52,211,153,.2);border-color:#34d399;color:#34d399}
.sg{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:10px}
.sc{background:rgba(0,0,0,.3);border-radius:8px;padding:12px}.sn{font-size:13px;font-weight:700;color:#f1f5f9;margin-bottom:4px}
.sr{font-size:11px;color:var(--mu);margin-bottom:6px}.si{font-size:11px;font-family:monospace}
.eb{margin-bottom:12px}.el{font-size:13px;font-weight:600;color:#cbd5e1;margin-bottom:6px}
table{width:100%;border-collapse:collapse}td,th{padding:8px 12px;border:1px solid var(--bd);font-size:12px;text-align:left}
th{background:rgba(255,255,255,.05);color:#94a3b8;font-weight:600}
td:first-child{font-weight:600;color:#f1f5f9}code{background:rgba(0,0,0,.4);padding:2px 5px;border-radius:4px;font-family:monospace;font-size:11px;color:#86efac}
.tags{display:flex;flex-wrap:wrap;gap:6px;margin-top:8px}.tag{background:rgba(248,113,113,.1);border:1px solid rgba(248,113,113,.2);border-radius:20px;padding:2px 10px;font-size:11px;color:#fca5a5}
.cr{display:flex;gap:12px;margin-bottom:10px;align-items:flex-start}
.cn{min-width:26px;height:26px;border-radius:50%;background:rgba(251,191,36,.15);color:#fbbf24;border:1px solid rgba(251,191,36,.3);display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;flex-shrink:0}
.ck{font-weight:700;color:#fbbf24;margin-right:6px}.ab{background:rgba(248,113,113,.08);border:1px solid rgba(248,113,113,.25);border-radius:8px;padding:12px;margin-top:12px}
.at{font-size:13px;font-weight:700;color:#f87171;margin-bottom:6px}.ai{font-size:12px;color:#fca5a5;padding:2px 0}
.ft{text-align:center;margin-top:28px;padding:16px;font-size:11px;color:var(--mu);border-top:1px solid var(--bd)}.swarn{background:rgba(251,191,36,.07);border:1px solid rgba(251,191,36,.3);border-radius:10px;padding:14px 16px;font-size:12px;color:#fde68a;line-height:1.7}.scat{margin-bottom:16px}.scath{font-size:12px;font-weight:700;color:#94a3b8;text-transform:uppercase;letter-spacing:.05em;margin-bottom:8px;padding-bottom:4px;border-bottom:1px solid rgba(255,255,255,.06)}.sit{background:rgba(0,0,0,.25);border-radius:8px;padding:10px 12px;margin-bottom:6px}.sin{font-size:12px;font-weight:600;color:#cbd5e1;margin-bottom:6px}.siv{display:flex;align-items:flex-start;gap:8px;flex-wrap:wrap}.svl{flex:1;background:rgba(0,0,0,.5);border:1px solid rgba(255,255,255,.1);border-radius:6px;padding:6px 10px;font-family:monospace;font-size:12px;color:#86efac;word-break:break-all;white-space:pre-wrap}@media print{#_sf,#_sc,#_sl,.swarn{display:none!important}}
@media print{body{background:#fff;color:#000}.page{max-width:100%}.topbar{background:#f5f5f5;border:1px solid #ccc}.toptitle{color:#000}.sec{background:#fafafa;border:1px solid #ddd;break-inside:avoid}pre{background:#f0f0f0;color:#111}.cp,.prbtn{display:none}h2{color:#000}.pc,.sc{background:#f5f5f5;border:1px solid #ddd}.sr,.si,.el,.ht{color:#333}.ab{background:#fff3f3;border:1px solid #ccc}.at,.ai{color:#900}.warn{background:#fff3f3;border:1px solid #ccc;color:#900}}`;

  const js = `function cp(b,t){navigator.clipboard.writeText(t).then(()=>{b.innerHTML='&#10003; OK';b.classList.add('ok');setTimeout(()=>{b.innerHTML='&#x2398; Копіювати';b.classList.remove('ok')},2000)}).catch(()=>{var a=document.createElement('textarea');a.value=t;document.body.appendChild(a);a.select();try{document.execCommand('copy')}catch(e){}document.body.removeChild(a);b.innerHTML='&#10003;';setTimeout(()=>{b.innerHTML='&#x2398; Копіювати'},1500)})}
const sb=${JSON.stringify(sb)};
const _ds={};
async function _db(pwd,blobStr){
  const b=JSON.parse(blobStr);
  const enc=new TextEncoder();
  const salt=Uint8Array.from(atob(b.salt),c=>c.charCodeAt(0));
  const iv=Uint8Array.from(atob(b.iv),c=>c.charCodeAt(0));
  const ct=Uint8Array.from(atob(b.ct),c=>c.charCodeAt(0));
  const km=await crypto.subtle.importKey('raw',enc.encode(pwd),'PBKDF2',false,['deriveKey']);
  const key=await crypto.subtle.deriveKey({name:'PBKDF2',salt,iterations:b.iter||200000,hash:'SHA-256'},km,{name:'AES-GCM',length:256},false,['decrypt']);
  const dec=await crypto.subtle.decrypt({name:'AES-GCM',iv},key,ct);
  return new TextDecoder().decode(dec);
}
async function _decAll(){
  const pwd=document.getElementById('_spwd').value;
  const serr=document.getElementById('_serr');
  if(!pwd){serr.textContent='⚠️ Введи Master Password';serr.style.display='block';return;}
  serr.style.display='none';
  const btn=document.getElementById('_sbtn');
  btn.textContent='⏳ Розшифровую...';btn.disabled=true;
  let ok=0;const res=[];
  for(const item of sb){
    try{const plain=await _db(pwd,item.blob);_ds[item.n]=plain;res.push({...item,ok:true});ok++;}
    catch(err){res.push({...item,ok:false});}
  }
  if(ok===0){
    serr.textContent='❌ Невірний пароль — жоден секрет не розшифровано';
    serr.style.display='block';
    btn.textContent='🔓 Розшифрувати';btn.disabled=false;
    return;
  }
  const cats={};
  for(const r of res){if(!r.ok)continue;if(!cats[r.cat])cats[r.cat]={em:r.em,items:[]};cats[r.cat].items.push(r);}
  let html='<div style="color:#34d399;font-size:12px;margin-bottom:14px;font-weight:600">✓ Розшифровано '+ok+' секретів · авто-очистка через <span id="_cdtxt">5:00</span></div>';
  for(const[cat,g]of Object.entries(cats)){
    html+='<div class="scat"><div class="scath">'+g.em+' '+cat+'</div>';
    for(const item of g.items){
      const sid='sv_'+btoa(unescape(encodeURIComponent(item.n))).replace(/[^a-zA-Z0-9]/g,'_');
      html+='<div class="sit"><div class="sin">'+item.n+'</div><div class="siv"><code class="svl" id="'+sid+'">···</code><button class="cp" data-key="'+btoa(unescape(encodeURIComponent(item.n)))+'" onclick="_scp(this)">&#x2398; Копіювати</button></div></div>';
    }
    html+='</div>';
  }
  document.getElementById('_sl').innerHTML=html;
  for(const r of res){
    if(!r.ok)continue;
    const sid='sv_'+btoa(unescape(encodeURIComponent(r.n))).replace(/[^a-zA-Z0-9]/g,'_');
    const el=document.getElementById(sid);
    if(el&&_ds[r.n])el.textContent=_ds[r.n];
  }
  document.getElementById('_sc').style.display='block';
  document.getElementById('_sf').style.display='none';
  _startCd();
}
function _scp(btn){
  const k=decodeURIComponent(escape(atob(btn.getAttribute('data-key'))));
  const val=_ds[k];
  if(!val)return;
  navigator.clipboard.writeText(val).then(()=>{
    btn.innerHTML='&#10003; OK';btn.classList.add('ok');
    setTimeout(()=>{btn.innerHTML='&#x2398; Копіювати';btn.classList.remove('ok');},2000);
  }).catch(()=>{
    const a=document.createElement('textarea');
    a.value=val;document.body.appendChild(a);a.select();
    try{document.execCommand('copy');}catch(e){}
    document.body.removeChild(a);
    btn.innerHTML='&#10003;';setTimeout(()=>{btn.innerHTML='&#x2398; Копіювати';},1500);
  });
}
let _cdTimer,_cdLeft=300;
function _startCd(){
  _cdLeft=300;
  clearInterval(_cdTimer);
  _cdTimer=setInterval(()=>{
    _cdLeft--;
    const m=Math.floor(_cdLeft/60),s=_cdLeft%60;
    const el=document.getElementById('_cdtxt');
    if(el)el.textContent=m+':'+String(s).padStart(2,'0');
    if(_cdLeft<=0)_clearAll();
  },1000);
}
function _clearAll(){
  clearInterval(_cdTimer);
  Object.keys(_ds).forEach(k=>delete _ds[k]);
  document.getElementById('_sc').style.display='none';
  document.getElementById('_sf').style.display='block';
  const pwd=document.getElementById('_spwd');if(pwd)pwd.value='';
  const btn=document.getElementById('_sbtn');if(btn){btn.textContent='🔓 Розшифрувати';btn.disabled=false;}
  const serr=document.getElementById('_serr');if(serr)serr.style.display='none';
  const sl=document.getElementById('_sl');if(sl)sl.innerHTML='';
}
(function(){function _fw(){var m=document.querySelector('.topmeta');if(!m)return;var t=m.textContent||'';var d=t.match(/Збережено:\\s*(\\d{4}-\\d{2}-\\d{2})/);if(!d)return;var sv=new Date(d[1]);if(isNaN(sv.getTime()))return;var days=Math.floor((Date.now()-sv.getTime())/86400000);if(days<=14)return;var old=days>30;var b=document.createElement('div');b.style.cssText=old?'background:rgba(248,113,113,.12);border:1px solid rgba(248,113,113,.4);border-radius:10px;padding:12px 16px;margin-bottom:18px;font-size:13px;color:#fca5a5':'background:rgba(251,191,36,.09);border:1px solid rgba(251,191,36,.35);border-radius:10px;padding:12px 16px;margin-bottom:18px;font-size:13px;color:#fde68a';b.innerHTML=old?'🚨 <b>Копія дуже стара ('+days+' днів).</b> Секрети МОЖУТЬ БУТИ НЕВАЛІДНІ — перевір актуальний стан перед використанням.':'⚠️ <b>Збережено '+days+' днів тому.</b> Секрети могли змінитись. Рекомендується оновити аварійну копію.';var pg=document.querySelector('.page');var tb=document.querySelector('.topbar');if(pg&&tb)pg.insertBefore(b,tb.nextSibling);}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',_fw);}else{_fw();}})();`;

  const tags = ['upload','file input','form','endpoint','route','admin','public URL','download','webhook','auth','token','key','password','CORS','redirect','subprocess','eval'].map(t=>`<span class="tag">${t}</span>`).join('');

  return `<!DOCTYPE html><html lang="uk"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1">
<title>Аварійна інструкція Katharsys ${e(dateStr)}</title><style>${css}</style></head><body><div class="page">
<div class="topbar"><div><div class="toptitle">🚨 Аварійна інструкція · Katharsys</div><div class="topmeta">Збережено: ${e(dateStr)} · Версія D-295 · MediaAutoUniqueizer</div></div><button class="prbtn" onclick="window.print()">🖨 Надрукувати</button></div>
<div class="warn">⚠️ Файл містить SSH-команди та системні шляхи. Зберігай на особистому захищеному носії. Не поширювати публічно.</div>
<div class="sec"><h2>⚡ Швидкий старт нової сесії Claude Code</h2>${projCards}</div>
<div class="sec"><h2>🖥️ Сервери</h2><div style="font-size:12px;color:#64748b;margin-bottom:10px">⚠️ WireGuard VPN обов'язковий перед SSH<br>${_dedNote}</div><div class="sg">${srvCards}</div></div>
<div class="sec"><h2>🔐 Аварійний SSH (без Claude)</h2>${sshCmds}</div>
<div class="sec"><h2>🔐 Секрети для аварійного відновлення</h2>${sb.length===0?'<div style="color:#64748b;font-size:13px;padding:8px 0">Секрети недоступні — Dashboard API не відповів під час збереження.<br>Використай розділ «🔑 Де знаходяться секрети» нижче.</div>':`<div class="swarn">⚠️ ІНСТРУКЦІЯ БЕЗПЕКИ ПЕРЕД ВИКОРИСТАННЯМ:<br>1. Відкривай тільки в браузері на особистому пристрої — не на чужому ПК<br>2. Введи той самий Master Password що використовуєш у Dashboard → 🔐 Безпека → Секрети<br>3. НІКОЛИ не вводь цей пароль у Claude / Telegram / Email / Google Docs<br>4. Скопіюй лише конкретний потрібний секрет — не роби скріншоти екрану з відкритими секретами<br>5. Після використання натисни «🗑 Очистити» або просто закрий вкладку браузера<br>6. Цей HTML-файл безпечний для зберігання на USB/хмарі — без пароля він марний</div>
<div id="_sf" style="margin-top:14px"><div style="display:flex;gap:10px;align-items:center;flex-wrap:wrap"><input type="password" id="_spwd" autocomplete="off" placeholder="Master Password від Dashboard → 🔐 Безпека → Секрети" style="flex:1;min-width:240px;background:rgba(0,0,0,.4);border:1px solid rgba(255,255,255,.2);border-radius:8px;padding:10px 14px;color:#e2e8f0;font-size:13px;outline:none;font-family:monospace" onkeydown="if(event.key==='Enter')_decAll()" /><button id="_sbtn" onclick="_decAll()" style="background:rgba(52,211,153,.15);border:1px solid rgba(52,211,153,.4);color:#34d399;border-radius:8px;padding:10px 20px;cursor:pointer;font-size:13px;font-weight:600;white-space:nowrap;transition:all .2s">🔓 Розшифрувати</button></div><div id="_serr" style="display:none;color:#f87171;font-size:12px;margin-top:8px"></div></div>
<div id="_sc" style="display:none;margin-top:14px"><div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:14px;flex-wrap:wrap;gap:8px"><div style="font-size:12px;color:#fbbf24;font-weight:600">⏱ Авто-очистка через <span id="_cdtxt">5:00</span> · після закриття вкладки секрети зникають з пам'яті</div><button onclick="_clearAll()" style="background:rgba(248,113,113,.1);border:1px solid rgba(248,113,113,.3);color:#f87171;border-radius:6px;padding:5px 14px;cursor:pointer;font-size:12px">🗑 Очистити зараз</button></div><div id="_sl"></div></div>`}</div>
<div class="sec"><h2>🔑 Де знаходяться секрети</h2><div style="font-size:12px;color:#64748b;margin-bottom:10px">Самі секрети тут НЕ зберігаються — тільки де шукати</div><table><tr><th>Що</th><th>Де</th></tr>${secretRows}</table></div>
<div class="sec"><h2>📁 Ключові файли</h2><div style="font-size:12px;color:#64748b;margin-bottom:10px">Репо: <code>/home/cc_media/videobot-docs/</code></div><table><tr><th>Файл</th><th>Призначення</th></tr>${fileRows}</table></div>
<div class="sec"><h2>🔒 Security тригери (перед кодом → SECURITY SCAN)</h2><div class="tags">${tags}</div></div>
<div class="sec"><h2>📜 5 Заповідей (нездоланні)</h2>
<div class="cr"><div class="cn">1</div><div><span class="ck">БЕЗПЕКА</span><span style="font-size:13px;color:#cbd5e1">Snapshot перед ризиком. Оцінка % ризику. Шлях відкату.</span></div></div>
<div class="cr"><div class="cn">2</div><div><span class="ck">ЗАВЕРШЕННЯ</span><span style="font-size:13px;color:#cbd5e1">Доводити до кінця. Не перескакувати.</span></div></div>
<div class="cr"><div class="cn">3</div><div><span class="ck">НАДІЙНІСТЬ</span><span style="font-size:13px;color:#cbd5e1">Будь-яка корисна підстраховка обов'язкова.</span></div></div>
<div class="cr"><div class="cn">4</div><div><span class="ck">ДЕЦИДНІСТЬ</span><span style="font-size:13px;color:#cbd5e1">Приймати рішення без затягування.</span></div></div>
<div class="cr"><div class="cn">5</div><div><span class="ck">ВЕРИФІКАЦІЯ</span><span style="font-size:13px;color:#cbd5e1">Звіряти реальний стан перед дією. Не покладатись на пам'ять.</span></div></div>
<div class="ab"><div class="at">🚨 Абсолютні правила</div>
<div class="ai">· Секрети/паролі/токени — НІКОЛИ в коді / чаті / репо</div>
<div class="ai">· Idle-gate — НІКОЛИ не рестартувати Celery при черзі &gt; 0</div>
<div class="ai">· git pull ПЕРЕД правкою спільних файлів (main.py, miniapp_routes.py)</div>
<div class="ai">· Читати COORDINATION.md перед деплоєм спільного файлу</div></div></div>
<div class="sec"><h2>📊 Стан проектів (на момент збереження: ${e(sd.generated_at||dateStr)})</h2>${[{id:'ava',label:'🎭 AVA — MediaAvatar',cl:'var(--ac2, #a78bfa)'},{id:'uniq',label:'🎬 UNIQ — Media Uniqueizer Bot',cl:'#34d399'},{id:'pl',label:'🎓 PL — PlayLanguage',cl:'#60a5fa'}].map(p=>{const raw=sd[p.id]||'';const ok=raw&&raw!=='файл не знайдено';return ok?`<div class="pc" style="border-left:3px solid ${p.cl}"><div class="pt">${e(p.label)}</div><pre style="margin-top:8px;font-size:11px;max-height:220px;overflow-y:auto;white-space:pre-wrap">${e(raw)}</pre></div>`:`<div class="pc" style="border-left:3px solid ${p.cl}"><div class="pt">${e(p.label)}</div><div style="color:#64748b;font-size:12px;margin-top:6px">Стан недоступний</div></div>`;}).join('')}</div>
<div class="ft">Katharsys MediaAutoUniqueizer · Аварійна інструкція · ${e(dateStr)}<br>Сформовано: Dashboard → Пам'ять АІ → Зберегти аварійну копію</div>
</div><script>${js}</script></body></html>`;
}

async function downloadEmergencyKit() {
  const now = new Date();
  const pad = n => String(n).padStart(2,'0');
  const dateStr = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())}`;
  const timeStr = `${pad(now.getHours())}:${pad(now.getMinutes())}`;
  const filename = `katharsys_emergency_${dateStr}.html`;

  // EMERGENCY-WIRE-20260819: воркери тягнемо ТУТ, на момент вивантаження, а не
  // беремо з коду — інакше аварійний документ застаріває так само, як застаріла
  // сама вкладка (у ній 5 тижнів висів сервер, видалений 10.07).
  let stateData = {}, secretsBlobs = [], dedRows = null;
  try {
    const [stateRes, secretsRes, dedRes] = await Promise.all([
      fetch('/api/emergency-state', _authOpts()),
      fetch('/api/emergency-secrets-export', _authOpts()),
      fetch('/api/dedicated/list', _authOpts()),
    ]);
    if (stateRes.ok) stateData = await stateRes.json();
    if (secretsRes.ok) secretsBlobs = await secretsRes.json();
    if (dedRes.ok) dedRows = await dedRes.json();
  } catch(err) { console.warn('API unavailable', err); }

  const html = buildEmergencyHTML(`${dateStr} ${timeStr}`, stateData, secretsBlobs, dedRows);
  const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  // revokeObjectURL тільки через 10с — браузер повинен встигнути почати завантаження
  setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 10000);
}

// ─── Головна сторінка ──────────────────────────────────────────────────────

export default function AIMemoryPage() {
  const TABS = [
    { id: 'projects', label: '🎯 Проекти', color: 'var(--ac2, #a78bfa)' },
    { id: 'system', label: '🌲 Система', color: '#34d399' },
    { id: 'bot', label: '🤖 Меню бота', color: '#60a5fa' },
    { id: 'servers',      label: '🖥️ Сервери',        color: '#fb923c' },
    { id: 'pending',      label: '📋 Pending',         color: '#f472b6' },
    { id: 'skills',       label: '⚡ Skills & Сесії',  color: '#86efac' },
    { id: 'commandments', label: '📜 Заповіді',         color: '#f59e0b' },
  ];
  const [tab, setTab] = useState('projects');
  const [lastSync, setLastSync] = useState(null);
  const [syncing, setSyncing] = useState(false);
  const [syncOk, setSyncOk] = useState(false);
  const [liveCoord, setLiveCoord] = useState(null);
  const [liveProjects, setLiveProjects] = useState({});
  const [downloading, setDownloading] = useState(false); // false | 'loading' | 'done'
  const [liveStatus, setLiveStatus] = useState(null);
  const [lsLoading, setLsLoading] = useState(false);
  const [pendingData, setPendingData] = useState(null);
  const [pendingLoading, setPendingLoading] = useState(false);
  // LIVE-DEDICATED-20260819: виділені воркери з БД, а не з коду
  const [dedServers, setDedServers] = useState(null);   // null = ще вантажиться
  const [dedError, setDedError] = useState(false);
  const activeColor = TABS.find(t => t.id === tab)?.color || 'var(--ac2, #a78bfa)';

  // LIVE-DEDICATED-20260819: тягнемо виділені воркери з того самого джерела,
  // яким користується сторінка «Система». Помилку показуємо, а не ховаємо:
  // мовчазний порожній список гірший за чесне «не вдалося оновити».
  useEffect(() => {
    fetch('/api/dedicated/list', _authOpts())
      .then(r => r.ok ? r.json() : Promise.reject(r.status))
      .then(rows => setDedServers(Array.isArray(rows) ? rows : []))
      .catch(() => { setDedError(true); setDedServers([]); });
  }, []);

  useEffect(() => {
    if (tab === 'pending' && !pendingData) {
      setPendingLoading(true);
      fetch('/api/emergency-state', _authOpts())
        .then(r => r.json())
        .then(d => {
          setPendingData(d.next_tasks || {});
          if (d.generated_at) setLastSync(d.generated_at);
        })
        .catch(e => console.error('pending-tasks error', e))
        .finally(() => setPendingLoading(false));
    }
  }, [tab]);

  const handleRefresh = async () => {
    setSyncing(true);
    setSyncOk(false);
    try {
      const r = await fetch('/api/emergency-state', _authOpts());
      const d = await r.json();
      setPendingData(d.next_tasks || {});
      if (d.live_status) setLiveCoord(d.live_status);
      setLastSync(d.generated_at || new Date().toLocaleString('uk-UA', { year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit' }));
      const lp = {};
      for (const id of ['ava', 'uniq', 'pl']) {
        if (d[id]) lp[id] = parseStateFile(d[id]);
      }
      setLiveProjects(lp);
      setSyncOk(true);
      setTimeout(() => setSyncOk(false), 2500);
    } catch(e) { console.error('refresh error', e); }
    finally { setSyncing(false); }
  };

  const fetchLiveStatus = async () => {
    setLsLoading(true);
    try {
      const r = await fetch('/api/servers/live-status', _authOpts());
      setLiveStatus(await r.json());
    } catch(e) { console.error('live-status error', e); }
    finally { setLsLoading(false); }
  };

  const handleDownload = async () => {
    if (downloading) return;
    setDownloading('loading');
    try {
      const now = new Date();
      const pad = n => String(n).padStart(2,'0');
      const dateStr = `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())}`;
      const timeStr = `${pad(now.getHours())}:${pad(now.getMinutes())}`;
      const filename = `katharsys_emergency_${dateStr}.html`;
      let stateData = {}, secretsBlobs = [];
      let dedRows2 = null;
      try {
        const [stateRes, secretsRes, dedRes] = await Promise.all([
          fetch('/api/emergency-state', _authOpts()),
          fetch('/api/emergency-secrets-export', _authOpts()),
          fetch('/api/dedicated/list', _authOpts()),
        ]);
        if (stateRes.ok) stateData = await stateRes.json();
        if (secretsRes.ok) secretsBlobs = await secretsRes.json();
        if (dedRes.ok) dedRows2 = await dedRes.json();
      } catch(e) { console.warn('API unavailable', e); }
      const html = buildEmergencyHTML(`${dateStr} ${timeStr}`, stateData, secretsBlobs, dedRows2);
      const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.style.cssText = 'position:fixed;top:-9999px;left:-9999px';
      document.body.appendChild(a);
      a.click();
      setDownloading('done');
      setTimeout(() => {
        document.body.removeChild(a);
        setDownloading(false);
        URL.revokeObjectURL(url);
      }, 5000);
    } catch(e) {
      console.error('download error', e);
      setDownloading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={{ ...s.header, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div style={s.title}>🧠 Пам'ять АІ</div>
          <div style={s.subtitle}>
            Інтерактивна карта системи Katharsys
            {lastSync
              ? <span style={{ color: '#4ade80', marginLeft: 8 }}>· Оновлено: {lastSync}</span>
              : <span style={{ color: '#64748b', marginLeft: 8 }}>· Натисни Оновити для синхронізації</span>}
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <button
            onClick={handleRefresh}
            disabled={syncing}
            style={{
              background: syncOk ? 'rgba(52,211,153,.25)' : syncing ? 'rgba(96,165,250,.25)' : 'rgba(96,165,250,.12)',
              border: `1px solid ${syncOk ? '#34d399' : syncing ? '#60a5fa' : 'rgba(96,165,250,.35)'}`,
              color: syncOk ? '#34d399' : '#60a5fa', borderRadius: 10, padding: '10px 14px',
              cursor: syncing ? 'default' : 'pointer', fontSize: 13, fontWeight: 600, transition: 'all .2s',
              minWidth: 120,
            }}
          >
            {syncOk ? '✓ Оновлено' : syncing ? '⏳ Читаю STATE...' : '📋 Оновити з STATE.md'}
          </button>
          <button
            onClick={handleDownload}
            disabled={downloading === 'loading'}
            style={{
              display: 'flex', alignItems: 'center', gap: 8,
              background: downloading === 'done' ? 'rgba(52,211,153,.3)' : downloading === 'loading' ? 'rgba(52,211,153,.15)' : 'rgba(52,211,153,.12)',
              border: `1px solid ${downloading ? '#34d399' : 'rgba(52,211,153,.35)'}`,
              color: '#34d399', borderRadius: 10, padding: '10px 18px',
              cursor: downloading === 'loading' ? 'default' : 'pointer', fontSize: 13, fontWeight: 600, transition: 'all .2s',
            }}
          >
            {downloading === 'done' ? '✓ Збережено' : downloading === 'loading' ? '⏳ Генерую...' : '⬇ Аварійна копія'}
          </button>
        </div>
      </div>

      <div style={s.syncBanner}>
        ⚡ Після кожної успішної зміни: оновити <code>_SESSIONS/[project]/STATE.md</code> → <code>COORDINATION.md</code> → <code>git push videobot-docs</code>
      </div>

      <div style={s.tabs}>
        {TABS.map(t => (
          <div key={t.id} style={s.tab(tab === t.id, t.color)} onClick={() => setTab(t.id)}>
            {t.label}
          </div>
        ))}
      </div>

      {/* ── Проекти ── */}
      {tab === 'projects' && (
        <div>
          <div style={{ ...s.subtitle, marginBottom: 16 }}>
            3 активних проекти · Натисни на проект для деталей
          </div>
          {PROJECTS.map(p => <ProjectCard key={p.id} proj={p} live={liveProjects[p.id]} />)}
        </div>
      )}

      {/* ── Система ── */}
      {tab === 'system' && (
        <div>
          <div style={{ ...s.card, background: 'rgba(0,0,0,.3)' }}>
            <div style={s.h3}>Інтерактивне дерево системи</div>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 16 }}>
              Натискай ▶ щоб розгорнути гілки
            </div>
            <TreeNode node={SYSTEM_TREE} depth={0} />
          </div>
        </div>
      )}

      {/* ── Меню бота ── */}
      {tab === 'bot' && (
        <div>
          <div style={{ ...s.card, background: 'rgba(0,0,0,.3)' }}>
            <div style={s.h3}>Дерево меню Telegram-бота</div>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 16 }}>
              Всі гілки навігації бота і mini-app · Натискай ▶ для розгортання
            </div>
            <TreeNode node={BOT_MENU_TREE} depth={0} />
          </div>
        </div>
      )}

      {/* ── Сервери ── */}
      {tab === 'servers' && (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 8 }}>
            <div style={s.subtitle}>Опорні сервери + виділені воркери (живі дані)</div>
            <button
              onClick={fetchLiveStatus}
              disabled={lsLoading}
              style={{
                display: 'flex', alignItems: 'center', gap: 6,
                background: lsLoading ? 'rgba(251,146,60,.25)' : 'rgba(251,146,60,.12)',
                border: `1px solid ${lsLoading ? '#fb923c' : 'rgba(251,146,60,.35)'}`,
                color: '#fb923c', borderRadius: 8, padding: '7px 14px',
                cursor: lsLoading ? 'default' : 'pointer', fontSize: 12, fontWeight: 600,
              }}
            >
              {lsLoading ? '⏳ Перевіряю...' : '🔄 Перевірити зараз'}
            </button>
          </div>
          {liveStatus ? (
            <div>
              <div style={{ fontSize: 11, color: '#64748b', marginBottom: 10 }}>
                Live дані · {liveStatus.checked_at}
                <button onClick={() => setLiveStatus(null)}
                  style={{ marginLeft: 12, background: 'none', border: 'none', color: '#475569',
                    cursor: 'pointer', fontSize: 11 }}>✕ Сховати</button>
              </div>
              <div style={s.grid}>
                {liveStatus.servers.map(srv => <LiveServerCard key={srv.id} data={srv} />)}
              </div>
            </div>
          ) : (
            <div>
              <div style={s.grid}>
                {SERVERS.map(srv => <ServerCard key={srv.name} server={srv} />)}
                {(dedServers || []).filter(d => d.status === 'active').map(d => (
                  <ServerCard key={d.name} server={_dedToCard(d)} />
                ))}
              </div>
              <div style={{ fontSize: 11, color: dedError ? '#f87171' : '#64748b', marginTop: 8 }}>
                {dedServers === null
                  ? '⏳ вантажимо виділені воркери…'
                  : dedError
                    ? '⚠️ не вдалося оновити список виділених воркерів — показані лише опорні сервери'
                    : `🟢 виділені воркери — живі дані з dedicated_servers (${(dedServers || []).filter(d => d.status === 'active').length} активних). Список оновлюється сам після кнопок «Створити»/«Видалити».`}
              </div>
            </div>
          )}
          <div style={{ ...s.card, marginTop: 16 }}>
            <div style={s.h3}>🔒 Приватна мережа</div>
            <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 10 }}>
              Сервери зʼєднані через Hetzner Private Network (10.0.0.x) та WireGuard VPN (10.8.0.x) — останній потрібен для тих, хто поза Hetzner (напр. netcup-1).
              Redis (10.0.0.3:6379) доступний тільки з приватної мережі.
            </div>
            <div style={s.h3}>📸 Snapshots</div>
            <div style={{ ...s.codeBlock }}>
{`# На n8n (10.0.0.3):
export HCLOUD_TOKEN=$(cat /root/.hcloud_token)
hcloud server create-image --type=snapshot --description "pre-X-YYYYMMDD" SERVER_NAME
hcloud image list --type=snapshot

# Автоматичний скрипт:
python3 /home/cc_media/videobot-docs/auto_snapshot.py SERVER_NAME KEEP_COUNT

# Останні (pre-redis-rotation, 2026-06-29):
# 402817496  pre-redis-rotation-n8n-20260629
# 402817498  pre-redis-rotation-test-20260629
# 402817495  pre-redis-rotation-worker1-20260629
# 402817497  pre-redis-rotation-staging-20260629`}
            </div>
          </div>
        </div>
      )}

      {/* ── Pending Tasks ── */}
      {tab === 'pending' && (
        <div>
          <div style={{ ...s.subtitle, marginBottom: 16 }}>
            Pending задачі · AVA + UNIQ + PL
          </div>
          {pendingLoading && (
            <div style={{ color: '#94a3b8', fontSize: 13, padding: 16 }}>⏳ Завантаження...</div>
          )}
          {!pendingLoading && pendingData && (
            <div>
              {[
                { id: 'ava',  label: '🎭 AVA — MediaAvatar',           color: 'var(--ac2, #a78bfa)' },
                { id: 'uniq', label: '🎬 UNIQ — Media Uniqueizer Bot', color: '#34d399' },
                { id: 'pl',   label: '🎓 PL — PlayLanguage',           color: '#60a5fa' },
              ].map(proj => {
                const tasks = pendingData[proj.id] || [];
                if (!tasks.length) return null;
                return (
                  <div key={proj.id} style={{ ...s.card, borderLeft: `3px solid ${proj.color}`, marginBottom: 12 }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: proj.color, marginBottom: 12 }}>
                      {proj.label}
                    </div>
                    {tasks.map((task, ti) => {
                      const PCLR = { '🔴': '#f87171', '🟡': '#fbbf24', '🟢': '#4ade80', '🔵': '#60a5fa' };
                      const clr = PCLR[task.priority] || '#94a3b8';
                      // Strip leading priority emoji from title for cleaner display
                      const title = task.title.replace(/^[🔴🟡🟢🔵🔜]\s*/, '').trim();
                      return (
                        <div key={ti} style={{ marginBottom: 10, paddingLeft: 8, borderLeft: `2px solid ${clr}22` }}>
                          <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginBottom: 4 }}>
                            <span style={{ fontSize: 14 }}>{task.priority}</span>
                            <span style={{ fontSize: 12, fontWeight: 600, color: clr }}>{title}</span>
                          </div>
                          {task.items.map((item, ii) => (
                            <div key={ii} style={{ fontSize: 11, color: '#94a3b8', paddingLeft: 12, marginBottom: 2 }}>
                              · {item}
                            </div>
                          ))}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
              <div style={{ fontSize: 11, color: '#475569', marginTop: 8 }}>
                Джерело: STATE.md кожного проекту · Оновлюється при git push
              </div>
            </div>
          )}
          {liveCoord && (
            <div style={{ ...s.card, marginTop: 8, background: 'rgba(0,0,0,.3)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <div style={s.h3}>🚥 LIVE STATUS (COORDINATION.md)</div>
                <CopyBtn text={liveCoord} />
              </div>
              <pre style={{ fontSize: 10, color: '#94a3b8', whiteSpace: 'pre-wrap', margin: 0, lineHeight: 1.5 }}>{liveCoord}</pre>
            </div>
          )}
        </div>
      )}

      {/* ── Skills ── */}
      {tab === 'skills' && (
        <div>
          <div style={{ ...s.card, background: 'rgba(134,239,172,.05)', borderColor: 'rgba(134,239,172,.2)', border: '1px solid' }}>
            <div style={s.h3}>🔑 Якір для нової сесії</div>
            <div style={{ fontSize: 13, color: '#94a3b8', marginBottom: 12 }}>
              Вставити у нову сесію Claude Code для миттєвої орієнтації:
            </div>
            {['/resume ava', '/resume uniq', '/resume pl'].map(cmd => (
              <div key={cmd} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                <div style={{ ...s.codeBlock, marginTop: 0, flex: 1 }}>{cmd}</div>
                <CopyBtn text={cmd} />
              </div>
            ))}
            <div style={{ fontSize: 12, color: '#64748b', marginTop: 8 }}>
              Файл якоря: <code style={s.code}>videobot-docs/_SESSIONS/ANCHOR.md</code>
            </div>
          </div>

          <div style={{ marginBottom: 8, ...s.h3 }}>⚡ Доступні skills</div>
          {SKILLS.map(sk => <SkillCard key={sk.cmd} skill={sk} />)}

          <div style={{ ...s.card, marginTop: 8 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
              <div style={s.h3}>📋 Checkpoint після успіху (обов'язково)</div>
              <CopyBtn text={`# 1. Оновити STATE.md проекту\n# videobot-docs/_SESSIONS/[project]/STATE.md\n\n# 2. Додати рядок у COORDINATION.md журнал\n\n# 3. Commit + push\ncd /home/cc_media/videobot-docs\ngit add _SESSIONS/[project]/STATE.md COORDINATION.md\ngit commit -m "docs: D-XXX [назва] — state sync"\nGIT_SSH_COMMAND="ssh -i ~/.ssh/id_ed25519_github" git push origin main`} />
            </div>
            <div style={{ ...s.codeBlock, marginTop: 0 }}>
{`# 1. Оновити STATE.md проекту
# videobot-docs/_SESSIONS/[project]/STATE.md

# 2. Додати рядок у COORDINATION.md журнал

# 3. Commit + push
cd /home/cc_media/videobot-docs
git add _SESSIONS/[project]/STATE.md COORDINATION.md
git commit -m "docs: D-XXX [назва] — state sync"
GIT_SSH_COMMAND="ssh -i ~/.ssh/id_ed25519_github" git push origin main`}
            </div>
          </div>

          <div style={s.card}>
            <div style={s.h3}>🔒 Security Auto-Check</div>
            <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 10 }}>
              При задачах з цими словами → ПЕРЕД кодом вивести ⚠️ SECURITY SCAN:
            </div>
            {['upload', 'file input', 'form', 'endpoint', 'route', 'admin', 'public URL', 'download', 'webhook', 'auth', 'token', 'key', 'password', 'CORS', 'redirect', 'subprocess'].map(t => (
              <span key={t} style={s.tag('#f87171')}>{t}</span>
            ))}
            <div style={{ marginTop: 10, fontSize: 12, color: '#64748b' }}>
              Деталі: <code style={s.code}>videobot-docs/_SESSIONS/SECURITY.md</code>
            </div>
          </div>
        </div>
      )}

      {/* ── Заповіді ── */}
      {tab === 'commandments' && (
        <div>
          <div style={{ ...s.subtitle, marginBottom: 16 }}>5 нездоланних заповідей проекту</div>
          {COMMANDMENTS.map(c => (
            <div key={c.num} style={{ ...s.card, borderLeft: '3px solid #f59e0b' }}>
              <div style={{ fontSize: 16, fontWeight: 700, color: '#fbbf24', marginBottom: 6 }}>
                Заповідь {c.num}: {c.name}
              </div>
              <div style={{ fontSize: 13, color: '#cbd5e1' }}>{c.desc}</div>
            </div>
          ))}
          <div style={{ ...s.card, borderLeft: '3px solid #ef4444', marginTop: 8 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#f87171', marginBottom: 6 }}>
              🚨 Абсолютні правила
            </div>
            <div style={{ fontSize: 13, color: '#cbd5e1', lineHeight: 1.8 }}>
              · Секрети/паролі/токени — НІКОЛИ в коді / чаті / репо<br/>
              · Idle-gate — НІКОЛИ не рестартувати Celery/бот при черзі &gt; 0<br/>
              · git pull — ОБОВ'ЯЗКОВО перед правкою спільних файлів (main.py, miniapp_routes.py)<br/>
              · Спільні файли — перевірити git diff що чужа зона ціла перед push
            </div>
          </div>
          <div style={{ ...s.card, marginTop: 8 }}>
            <div style={s.h3}>📖 Повні правила</div>
            <div style={{ fontSize: 12, color: '#94a3b8' }}>
              <code style={s.code}>/home/cc_media/videobot-docs/WORKING_RULES.md</code>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
